// extracted by mini-css-extract-plugin
export default {"account-row":"StartJuForm_account-row__IQwlc","account-col":"StartJuForm_account-col__jc8BM"};